
class OctaneWrapper
extends HTMLElement {

    controller = new AbortController

    constructor (){

        super()

        this.customDataCookieName = 'custom_product_data'
        this.validUrlParams = [ 'returnTo' ]
        this.defaultRedirectUrl = this.dataset.defaultRedirectUrl

        this._onQuizCompletedListener = this._onQuizCompleted.bind(this)

        this.concernData = [ -1 , -1 , -1 ]
        this.firstConcernStepNumber = parseInt(this.dataset.firstConcernQuestion)

        this.observer = new MutationObserver(( mutations ) => {

            for ( let mutation of mutations ){
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                    this._findAndChangeInputType(node);
                    this._checkForConcernQuestions(node);
                    });
                }
            }
        })

        this.observerConfig = {
            childList : true ,
            subtree : true
        }
    }

    connectedCallback (){

        const { signal } = this.controller

        document.addEventListener('octane.quiz.completed',this._onQuizCompletedListener,{ signal })
        document.addEventListener('octane.quiz.accessed',this._onQuizCompletedListener,{ signal })
        this.observer.observe(this,this.observerConfig)
    }

    disconnectedCallback (){
        this.observer.disconnect()
        this.controller.abort()
    }

    _onQuizCompleted ( event ){

        const data = event.detail.answers

        const json = JSON.stringify(data)

        console.debug('OctaneWrapper::_onQuizCompleted',{ json })

        this._setCookie(json,1)
        this._redirectAfterQuizCompleted()
    }

    _setCookie ( value , days ){

        const Day = 24 * 60 * 60 * 1000

        const date = new Date
        date.setTime( date.getTime() + days * Day )

        let expires = `expires=${ date.toUTCString() }`

        const name = this.customDataCookieName

        document.cookie = `${ name }=${ value };${ expires };path=/`
    }

    _getValidUrlParams (){

        const { search } = location

        let params = new URLSearchParams(search)

        let validParams = {}

        for ( let key of params.keys() )
            if( this.validUrlParams.includes(key) )
                validParams[key] = params.get(key);

        for (let key of this.validUrlParams ){

            if( ! validParams.hasOwnProperty(key) )
                return false

            if( validParams[key] === '' )
                return false
        }

        return validParams
    }

    _redirectAfterQuizCompleted (){

        const directTo = this
            ._getValidUrlParams()

        if( directTo ){
            location.href = location.origin + directTo["returnTo"];
        } else {
            location.href = location.origin + this.defaultRedirectUrl;
        }
    }

    _checkForConcernQuestions(node) {
        const stepSelector = ".oct-quiz-caption-text";

        if (node.classList && (node.classList.contains('oct-quiz-top_content'))) {
            if (node.querySelector(stepSelector)) {
            const stepContent = node.querySelector(stepSelector).textContent;
            const stepNumber = parseInt(stepContent.split(" von ")[0]);

            if (stepNumber >= this.firstConcernStepNumber && stepNumber <= this.firstConcernStepNumber + 2) {
                const stepIndex = stepNumber - this.firstConcernStepNumber;

                this._registerConcernOptionEventListeners(this.querySelectorAll(".oct-quiz-content li"), stepIndex);

                if (stepNumber === this.firstConcernStepNumber) {

                } else if (stepNumber == this.firstConcernStepNumber + 1) {
                if (this.concernData[stepIndex - 1] != -1) {
                    this.querySelector(`.oct-quiz-content li[data-option-index='${this.concernData[stepIndex - 1] + 1}']`).style.display = "none";
                }
                } else if (stepNumber == this.firstConcernStepNumber + 2) {
                if (this.concernData[stepIndex - 1] != -1) {
                    this.querySelector(`.oct-quiz-content li[data-option-index='${this.concernData[stepIndex - 1]}']`).style.display = "none";
                }
                if (this.concernData[stepIndex - 2] != -1) {
                    this.querySelector(`.oct-quiz-content li[data-option-index='${this.concernData[stepIndex - 2] + 1}']`).style.display = "none";
                }
                }
            }
            }
        }
    }

    _registerConcernOptionEventListeners(nodes, stepIndex) {
        nodes.forEach((node) => {
            node.addEventListener("click", (e) => {
            const li = e.target.closest("li");
            const optionIndex = parseInt(li.dataset.optionIndex);
            if (stepIndex > 0 && optionIndex == 0) {
                return;
            }
            this.concernData[stepIndex] = optionIndex;
            });
        });
    }

    _findAndChangeInputType(node) {
        if (node.tagName && node.tagName.toLowerCase() === 'input') {
            // Change the input type
            if (node.placeholder == 'Alter'){
            node.type = 'number';
            node.min = 0;
            node.max = 100;
            this.observer.disconnect();
            }
        } else if (node.childNodes && node.childNodes.length > 0) {
            // If the node has child nodes, recursively check each child
            for (const childNode of node.childNodes) {
                this._findAndChangeInputType(childNode);
            }
        }
    }
}


window.customElements.define(
    'octane-wrapper' ,
    OctaneWrapper
)
